<div class="main p-1" [ngClass]="{'mobile': isHandset}">
  <div id="gatewayTitle" class="ps-sm-5 pe-sm-5">
    <h1>US Civil War Archives</h1>
    <h3>Please choose a library to browse</h3>
  </div>
  <div id="gatewayBox" [ngClass]="{'mobile': isHandset}" class="ps-sm-5 pe-sm-5">
<!--  -->
    <app-lib-select-button [displayName]="'Photographs & Images'" [config]="gatewayLibSelects.PhotosLibSelect" (clickedEmitter)="setPageOut($event)" [browseText]="noOfRecordsString('photo')"></app-lib-select-button>
    <app-lib-select-button [displayName]="'Letters & Diaries'" [config]="gatewayLibSelects.LettersLibSelect" (clickedEmitter)="setPageOut($event)" [browseText]="noOfRecordsString('letterAndDiaries')"></app-lib-select-button>
    <app-lib-select-button [displayName]="'US Ordnance Returns'" [config]="gatewayLibSelects.OrdnanceReturnsLibSelect" (clickedEmitter)="setPageOut($event)" [browseText]="noOfRecordsString('ordnanceReturns')"></app-lib-select-button>
    <!-- <div class="outerBtn" (click)="setPageOut(photosLibraryTypeName)">
      <div class="btnTitle">
        Photographs &amp; Images
      </div>
      <div class="browseText">Browse</div>
        <div class="innerBtn">
          <div id="photosBtn" class="partialBtn">
        </div>
      </div>
    </div>

    <div class="outerBtn" (click)="setPageOut(lettersLibraryTypeName)">
      <div class="btnTitle">
        Letters &amp; Diaries
      </div>
      <div class="browseText">Browse</div>
      <div class="innerBtn">
        <div id="lettersBtn" class="partialBtn">
        </div>
      </div>
    </div>

    <div class="outerBtn" (click)="setPageOut(ordnanceReturnLibraryTypeName)">
      <div class="btnTitle" >
        US Ordnance Returns
      </div>
      <div class="browseText">Browse</div>
      <div class="innerBtn">
        <div id="ordnanceBtn" class="partialBtn">
        </div>
      </div>
    </div> -->

    <!-- 3/11 -->

    <app-lib-select-button *ngIf="!isHandset" [displayName]="'Quartermaster & Ordnance Specs'" [config]="gatewayLibSelects.QMSpecsLibSelect" matTooltip="Quartermaster Specifications and Ordnance Manuals" [browseText]="noOfRecordsString('quartermaster')" (clickedEmitter)="setPageOut($event)"></app-lib-select-button>
    <app-lib-select-button [displayName]="'General/Special Orders'" [config]="gatewayLibSelects.GSOrdersLibSelect"[browseText]="noOfRecordsString('generalSpecialOrders')" (clickedEmitter)="setPageOut($event)"></app-lib-select-button>
    <app-lib-select-button [config]="gatewayLibSelects.MorningReportsLibSelect" [browseText]="noOfRecordsString('morningReports')" (clickedEmitter)="setPageOut($event)"></app-lib-select-button>
    <!-- <div class="outerBtn" (click)="openQuartermasterManuals()">
      <div class="btnTitle" matTooltip="Quartermaster Specifications and Ordnance Manuals">
        Quartermaster &amp; Ordnance Specs
      </div>
      <div class="browseText">Browse</div>
      <div class="innerBtn">
        <div id="qtrMasterBtn" class="partialBtn">
        </div>
      </div>
    </div>

    <div class="outerBtn" (click)="setPageOut(generalSpecialOrdersLibraryTypeName)">
      <div class="btnTitle">
        General/Special Orders
      </div>
      <div class="browseText">Browse</div>
      <div class="innerBtn">
        <div id="generalSpecialOrdersBtn" class="partialBtn">
        </div>
      </div>
    </div>

    <div class="outerBtn" (click)="setPageOut(morningReportsLibraryTypeName)">
      <div class="btnTitle">
        Morning Reports
      </div>
      <div class="browseText">Browse</div>
      <div class="innerBtn">
        <div id="morningReportsBtn" class="partialBtn">
        </div>
      </div>
    </div> -->

    <!-- 6/11 -->

    <app-lib-select-button [config]="gatewayLibSelects.MusterRollsLibSelect" [browseText]="noOfRecordsString('musterRolls')" (clickedEmitter)="setPageOut($event)"></app-lib-select-button>
    <app-lib-select-button [config]="gatewayLibSelects.ClothingLedgerBooksLibSelect" [browseText]="noOfRecordsString('clothingLedger')"(clickedEmitter)="setPageOut($event)"></app-lib-select-button>

    <app-lib-select-button [displayName]="'Unit Ledgers'" [config]="gatewayLibSelects.LedgerSetsLibSelect" [browseText]="noOfRecordsString('ledgerSets')" (clickedEmitter)="setPageOut($event)"></app-lib-select-button>

    <app-lib-select-button [displayName]="'Military Forms (Pre-printed)'" [config]="gatewayLibSelects.MilitaryFormsLibSelect" [browseText]="noOfRecordsString('military')" (clickedEmitter)="setPageOut($event)"></app-lib-select-button>
    <!-- <div class="outerBtn" (click)="setPageOut(musterRollsLibraryTypeName)">
      <div class="btnTitle">
        Muster Rolls
      </div>
      <div class="browseText">Browse</div>
      <div class="innerBtn">
        <div id="musterRollsBtn" class="partialBtn">
        </div>
      </div>
    </div>

    <div class="outerBtn" (click)="setPageOut(clothingLedgerBooksLibraryTypeName)">
      <div class="btnTitle">
        Clothing Ledger/Books
      </div>
      <div class="browseText">Browse</div>
      <div class="innerBtn">
        <div id="clothingLedgerBooksBtn" class="partialBtn placeholder">
        </div>
      </div>  
    </div>

    <div class="outerBtn" (click)="openPrePrintedMilitaryForms()">
      <div class="btnTitle">
        Military Forms (Pre-printed)
      </div>
      <div class="browseText">Browse</div>
      <div class="innerBtn">
        <div id="militaryPreprintedFormsBtn" class="partialBtn placeholder">
        </div>
      </div>  
    </div> -->

    <!-- 9/11 -->

    <div class="outerBtn" (click)="openCivilianResearch()">
      <div class="btnTitle">
        Civilian Research
      </div>
      
      <div class="browseText"> <i class="far fa-search"></i> {{noOfRecordsString('civilian')}}</div>
      <div class="innerBtn">
        <div id="civilianResearchBtn" class="partialBtn">
        </div>
      </div>  
    </div>

    <div class="outerBtn" (click)="openMicrofilmSearch()">
      <div class="btnTitle" >
        Search Nara Records
      </div>
      <div class="browseText"><i class="far fa-search"></i> {{noOfRecordsString('nara')}}</div>
      <div class="innerBtn">
        <div id="microfilmSearchBtn" class="partialBtn">
        </div>
      </div>  
    </div> 

    <div class="outerBtn" (click)="openSearch()">
      <div class="btnTitle" >
        Search by Source/Call #
      </div>
      <div class="browseText"> <i class="far fa-search"></i> {{noOfRecordsString('search')}}</div>
      <div class="innerBtn">
        <div id="sourceCallNoBtn" class="partialBtn">
        </div>
      </div>  
    </div> 

    <!-- 11/11 -->
  </div>
  <!-- Tile 12 "View All"... -->
  <div id="allBtn" (click)="setPageOut()">
    View All
    <span class="fa-stack">
      <i class="fas fa-th fa-stack-1x" style="margin-top: .15em; margin-left: .15em; color: rgba(225, 225, 225, .33);" ></i>
      <i class="fas fa-th fa-stack-1x"></i>
    </span>
  </div>

</div>
<app-site-footer></app-site-footer>
